/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const HeadsetSolidV6 = (props) => (
  <Icon {...props} name="Headset Solid V6">
    <path d="M5.972 7a1 1 0 0 0-1-1.001L4.5 6c-1.104 0-2 .896-2 2.002v1.493c0 1.107.897 2.004 2 2.004H5c.552 0 1-.449 1-1.002l-.028-3.498zM8 0C3.528 0 .143 3.722.001 8L0 9.25c0 .416.336.75.722.75s.778-.334.778-.75V8c0-3.584 2.917-6.494 6.5-6.494 3.584 0 6.5 2.909 6.5 6.494v4.5c0 .69-.56 1.25-1.25 1.25H9.791A1.49 1.49 0 0 0 8.5 13h-.944c-.725 0-1.391.49-1.527 1.203-.185.96.546 1.797 1.443 1.797H8.5c.554 0 1.032-.303 1.292-.75h3.458A2.75 2.75 0 0 0 16 12.5V8c-.144-4.278-3.528-8-8-8zm3.5 11.5c1.104 0 2-.897 2-2.004V8.003A2.003 2.003 0 0 0 11.5 6H11a1 1 0 0 0-1 1.001v3.496a1 1 0 0 0 1 1.003h.5z" />
  </Icon>
);

export default HeadsetSolidV6;
